import * as listWarrantiesReducer from './list';
import * as listCategoriesWarrantiesReducer from './listCategories';
import * as listImageReducer from './images';
import * as updateReducer from './update';
import * as insertExcelReducer from './insertExcel';

const Reducers = {
  ...listWarrantiesReducer,
  ...listCategoriesWarrantiesReducer,
  ...listImageReducer,
  ...updateReducer,
  ...insertExcelReducer,
};

export default Reducers;
